import React, { Component } from "react";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
import DataStore from "./../../../stores/DataStore";

/**
 * @class
 * Zur Anzeige eines einzelnen Sliders
 * @name SliderAttribute
 * @implements {Attribute}
 */
class SliderAttribute extends Component {
  constructor(params) {
    super(params);
  }

  onChange(event, newValue) {
    const { attribute: { onChange, value = "" } = {} } = this.props;
    onChange(newValue);
  }

  getValueString() {
    const { value = 0 } = DataStore.attributeValues[this.id];
    return value.toString();
  }

  getSummaryDisplay() {
    return <div>{this.getValueString()}</div>;
  }

  getValue() {
    const { value } = DataStore.attributeValues[this.id];
    if (!value) return 0;
    return value;
  }

  render() {
    const {
      attribute: {
        id = "",
        name = "",
        attributeOption: {
          Sld = Slider,
          Typo = Typography,
          SliderProps = {},
          TypographyProps = {},
        },
        steps = 1,
        min = 0,
        max = 100,
        attributeModul,
      } = {},
    } = this.props;
    attributeModul.holdedAttribute = this;
    this.id = id;
    return (
      <div
        style={{
          flexGrow: 1,
          marginRight: "5px",
        }}
      >
        <Typo {...TypographyProps} id={`${id}label`} gutterBottom>
          {name}
        </Typo>
        <Sld
          defaultValue={DataStore.attributeValues[this.id].value}
          value={DataStore.attributeValues[this.id].value}
          disabled={DataStore.attributeValues[this.id].readOnly}
          // getAriaValueText={valuetext}
          aria-labelledby={`${id}label`}
          step={steps}
          // marks
          min={min}
          max={max}
          onChange={(event, newValue) => this.onChange(event, newValue)}
          valueLabelDisplay="auto"
          {...SliderProps}
        />
      </div>
    );
  }
}

export default SliderAttribute;
